import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useNewWebsite } from "context/client/new_website";

import ModalNew from "components/ModalNew";
import FormikInput from "components/formik/FormikInput";
import Button from "components/Button";

import domainSchema from "libs/validations/new_website_form/domainSchema";

const mainClass = "new-website-content__widget__domain";

const DomainModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const { saveData, form_data } = useNewWebsite();

  const onSubmit = (values) => {
    saveData(values);

    if (typeof onClose === "function") onClose();
  };

  return (
    <ModalNew
      title={t("Change the website address")}
      description={t("Update the domain that will be managed by us.")}
      hasMobileScrollTop={false}
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <Formik
        initialValues={{
          website: form_data?.website || "",
        }}
        validationSchema={domainSchema}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values, setSubmitting);
        }}
      >
        {({ isSubmitting }) => (
          <Form className={mainClass} autoComplete="off">
            <FormikInput
              name="website"
              label={t("Domain")}
              placeholder="example.com"
              disabled={isSubmitting}
              required
            />
            <div className={`${mainClass}__cta`}>
              <Button type="submit">{t("Update data")}</Button>
            </div>
          </Form>
        )}
      </Formik>
    </ModalNew>
  );
};

export default DomainModal;
